import { Button, Form, message, Modal, notification } from "antd";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { closeModal } from "store/slices/modalsSlice";
import ExpenseForm from "./expense-form";
import useExpenses from "hooks/useExpenses";
const EditEmployeeModal = () => {
    const { t } = useTranslation();
    const [form] = Form.useForm();
    const dispatch = useDispatch();
    const { isModalOpen, modalType, modalProps } = useSelector(
        (state) => state.modals
    );
    const { getExpenseById, updateExpense, expense, setExpense, isLoading, error, setError } = useExpenses();
    const [isSendForUpdate, setIsSendForUpdate] = useState(false);
  
    useEffect(() => {
      if (expense) {
          form.setFieldsValue({
              ...expense,
              creationDate: expense.creationDate ? dayjs(expense.creationDate) : null,
              expenseTypeId: expense.type?.id, 
          });
      }
  }, [expense]);


    useEffect(() => {
        if (modalProps?.expenseId) {
            setExpense(null);
            const getExpense = async () => {
                try {
                    await getExpenseById(modalProps.expenseId);
                } catch (error) {
                    console.log("Erreur lors de la récupération de la dipense", error);
                }
            };
            getExpense();
        }
    }, [modalProps?.expenseId]);


    useEffect(() => {
        if (isSendForUpdate) {
            if (error) {
                message.error(
                    t("expenses.crud.form.error.edit") + " " + error
                )
            } else {
                message.success(
                    t("expenses.crud.form.edit.success")
                )
                onClose();
            }
            setIsSendForUpdate(false);
        }
    }, [isSendForUpdate, error]);
    const open = isModalOpen && modalType === "edit_expense";

    const onSubmit = async (values) => {
        setError(null);
        setIsSendForUpdate(false);
        try {
            const formattedDate = dayjs(values.creationDate.$d).format("YYYY-MM-DD");
            values.creationDate = formattedDate;
            values.price = Number(values.price);
            await updateExpense(values, modalProps?.expenseId);
        } catch (error) {
            notification.error({
                message: t("expenses.crud.form.error.edit"),
                description: error,
                role: "alert",
                duration: 3,
            });
        } finally {
            setIsSendForUpdate(true);
        }
    };

    const onClose = () => {
        form.resetFields();
        dispatch(closeModal());
    };
    return (
        <Modal
            title={
                <h4 style={{ textAlign: "center" }}>{t("expenses.crud.form.title.modification")}</h4>
            }
            open={open}
            onCancel={onClose}
            destroyOnClose
            footer={[
                <Button key="cancel" onClick={onClose} className="custom-btn-1">
                    {t("expenses.crud.form.button.cancel")}
                </Button>,
                <Button
                    key="submit"
                    type="primary"
                    htmlType="submit"
                    form="expense_form"
                    disabled={isLoading}
                    className="custom-btn-2"
                >
                    {t("expenses.crud.form.button.save")}
                </Button>,
            ]}
            centered={true} 
            styles={{ content: { overflowY: "auto", maxHeight: "75vh", width: "100%" } }}
        >
            <ExpenseForm form={form} onSubmit={onSubmit} />
        </Modal>
    );
};

export default EditEmployeeModal;
